import React, { useEffect, useState } from 'react'
import { Modal } from 'react-responsive-modal'
import {
  CreateSimpleTaskType,
  InitialState,
} from '../../containers/AdminLessonBlocksPage/types'
import { ModuleType } from '../../containers/ModulePage/types'
import { BlockType } from '../../containers/LessonPage/types'
import { useSelector } from 'react-redux'
import usePrevious from '../../hooks/usePrevious'

// Styles
import './styles.scss'

// Modal styles
const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 400,
    borderRadius: 20,
    padding: 20,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

export default ({
  modal,
  modules,
  blocks,
  module_id,
  simpleTaskBlockId,
  onUpdate,
  onCreate,
  onSync,
  onClose,
}: {
  modal: boolean
  modules: ModuleType[]
  blocks: BlockType[]
  module_id: string
  simpleTaskBlockId: null | string
  onUpdate: (block_id: string, data: CreateSimpleTaskType) => void
  onCreate: (data: CreateSimpleTaskType) => void
  onSync: (simple_task_id: string) => void
  onClose: (open: boolean) => void
}) => {
  const data = {
    type: 'text',
    module_id,
    notion_description_id: '',
    caption: '',
    description: '',
    show_field: 0,
    field_caption: '',
    field_required: 0,
    show_file: 0,
    file_caption: 'Прикрепить файл',
    file_required: 0,
    task_required: 0,
  }

  const currentBlock = simpleTaskBlockId
    ? blocks.find(block => block.block_id === simpleTaskBlockId)
    : false

  const currentSimpleTaskId = currentBlock
    ? currentBlock.simple_task?.simple_task_id || ''
    : ''

  const [simpleTaskData, setSimpleTaskData] = useState(data)
  const [initialNotionId, setInitialNotionId] = useState<string | null>(null)
  const [isNotionSync, setIsNotionSync] = useState<boolean>(false)

  const { processIsFetchingSimpleTaskNotion } = useSelector(
    (state: { adminLessonBlocks: InitialState }) => state.adminLessonBlocks
  )

  const prevProcessIsFetchingNotion = usePrevious(
    processIsFetchingSimpleTaskNotion
  )

  useEffect(() => {
    if (!processIsFetchingSimpleTaskNotion && prevProcessIsFetchingNotion) {
      setIsNotionSync(true)
    }
  }, [processIsFetchingSimpleTaskNotion])

  useEffect(() => {
    if (modal) {
      setSimpleTaskData(data)
      if (currentBlock && currentBlock.simple_task) {
        const {
          notion_page_id,
          caption,
          description,
          show_field,
          field_caption,
          field_required,
          show_file,
          file_caption,
          file_required,
          task_required,
        } = currentBlock.simple_task.task
        setSimpleTaskData({
          type: notion_page_id ? 'notion' : 'text',
          module_id: currentBlock.simple_task.module_id,
          notion_description_id: notion_page_id,
          caption,
          description,
          show_field: show_field ? 1 : 0,
          field_caption,
          field_required: field_required ? 1 : 0,
          show_file: show_file ? 1 : 0,
          file_caption,
          file_required: file_required ? 1 : 0,
          task_required: task_required ? 1 : 0,
        })
        setInitialNotionId(notion_page_id)
        setIsNotionSync(false)
      }
    }
  }, [modal])

  const handleChangeData = (type: string, value: string | number) => {
    setSimpleTaskData({ ...simpleTaskData, ...{ [type]: value } })
  }

  const handleCreateBlock = () => {
    onCreate(simpleTaskData)
  }

  const handleUpdateBlock = () => {
    if (currentBlock && currentBlock.block_id) {
      onUpdate(currentBlock.block_id, simpleTaskData)
    }
  }

  return (
    <Modal
      open={modal}
      styles={customModalStyles}
      onClose={() => onClose(false)}
      center={true}
    >
      <div className={'admin-simple-task-block'}>
        <h3 style={{ margin: 0, marginBottom: 10 }}>
          {simpleTaskBlockId ? 'Изменить' : 'Добавить'} блок Simple Task
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label htmlFor={'modules'}>Модуль</label>
          <select
            style={{ marginBottom: 10 }}
            id={'modules'}
            value={simpleTaskData['module_id']}
            onChange={event =>
              handleChangeData('module_id', event.target.value)
            }
          >
            {modules
              .sort((a, b) =>
                a.module_id === module_id
                  ? -1
                  : b.module_id === module_id
                  ? 1
                  : 0
              )
              .map(module => (
                <option key={module.module_id} value={module.module_id}>
                  {module.title}
                </option>
              ))}
          </select>
          <label htmlFor={'type'}>Тип описания</label>
          <select
            style={{ marginBottom: 10 }}
            id={'type'}
            value={simpleTaskData['type']}
            onChange={event => handleChangeData('type', event.target.value)}
          >
            <option value={'text'}>Текстовое описание</option>
            <option value={'notion'}>Notion Description</option>
          </select>
          {simpleTaskData.type === 'text' ? (
            <>
              <label htmlFor={'text-description'}>Текстовое описание</label>
              <textarea
                style={{ margin: '0 0 10px', outline: 0 }}
                id={'text-description'}
                placeholder={''}
                autoComplete={'off'}
                value={simpleTaskData['description']}
                rows={4}
                onChange={event =>
                  handleChangeData('description', event.target.value)
                }
              />
            </>
          ) : (
            <>
              <label htmlFor={'notion-description-id'}>
                Notion Description ID
              </label>
              <input
                style={{ margin: '0 0 10px', outline: 0 }}
                id={'notion-description-id'}
                type={'text'}
                placeholder={''}
                autoComplete={'off'}
                value={simpleTaskData['notion_description_id']}
                onChange={event =>
                  handleChangeData('notion_description_id', event.target.value)
                }
              />
              {simpleTaskBlockId &&
              initialNotionId === simpleTaskData['notion_description_id'] &&
              simpleTaskData['notion_description_id'] &&
              !isNotionSync ? (
                <button
                  onClick={() => onSync(currentSimpleTaskId)}
                  style={{ margin: '0 0 10px', outline: 0 }}
                >
                  Синхронизировать
                </button>
              ) : null}
              {isNotionSync ? (
                <span
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    color: 'green',
                    marginBottom: 7,
                  }}
                >
                  Синхронизированно
                </span>
              ) : null}
            </>
          )}
          <label htmlFor={'title'}>Заголовок задания</label>
          <input
            style={{ margin: '0 0 10px', outline: 0 }}
            id={'title'}
            type={'text'}
            placeholder={''}
            autoComplete={'off'}
            value={simpleTaskData['caption']}
            onChange={event => handleChangeData('caption', event.target.value)}
          />
          <div className={'admin-simple-task-block__row'}>
            <input
              id={'show-text'}
              type={'checkbox'}
              value={simpleTaskData['show_field']}
              checked={!!simpleTaskData['show_field']}
              onChange={() =>
                handleChangeData(
                  'show_field',
                  simpleTaskData['show_field'] ? 0 : 1
                )
              }
            />
            <label htmlFor={'show-text'}>Показать текстовое поле</label>
          </div>
          {simpleTaskData.show_field ? (
            <div style={{ margin: '7px 0 7px 22px' }}>
              <label htmlFor={'caption-file'}>Заголовок текстового поля</label>
              <input
                style={{ margin: '0 0 10px', outline: 0, width: '100%' }}
                id={'caption-file'}
                type={'text'}
                placeholder={''}
                autoComplete={'off'}
                value={simpleTaskData['field_caption']}
                onChange={event =>
                  handleChangeData('field_caption', event.target.value)
                }
              />
              <div className={'admin-simple-task-block__row'}>
                <input
                  id={'require-text'}
                  type={'checkbox'}
                  value={simpleTaskData['field_required']}
                  checked={!!simpleTaskData['field_required']}
                  onChange={() =>
                    handleChangeData(
                      'field_required',
                      simpleTaskData['field_required'] ? 0 : 1
                    )
                  }
                />
                <label htmlFor={'require-text'}>Обязательное поле</label>
              </div>
            </div>
          ) : null}
          <div className={'admin-simple-task-block__row'}>
            <input
              id={'require-file'}
              type={'checkbox'}
              value={simpleTaskData['show_file']}
              checked={!!simpleTaskData['show_file']}
              onChange={() =>
                handleChangeData(
                  'show_file',
                  simpleTaskData['show_file'] ? 0 : 1
                )
              }
            />
            <label htmlFor={'require-file'}>Нужно прикрепить файл</label>
          </div>
          {simpleTaskData.show_file ? (
            <div style={{ margin: '7px 0 7px 22px' }}>
              <label htmlFor={'caption-upload-file'}>
                Заголовок загрузки файла
              </label>
              <input
                style={{ margin: '0 0 10px', outline: 0, width: '100%' }}
                id={'caption-upload-file'}
                type={'text'}
                placeholder={''}
                autoComplete={'off'}
                value={simpleTaskData['file_caption']}
                onChange={event =>
                  handleChangeData('file_caption', event.target.value)
                }
              />
              <div className={'admin-simple-task-block__row'}>
                <input
                  id={'require-upload-file'}
                  type={'checkbox'}
                  value={simpleTaskData['file_required']}
                  checked={!!simpleTaskData['file_required']}
                  onChange={() =>
                    handleChangeData(
                      'file_required',
                      simpleTaskData['file_required'] ? 0 : 1
                    )
                  }
                />
                <label htmlFor={'require-upload-file'}>Обязательное поле</label>
              </div>
            </div>
          ) : null}
          <div className={'admin-simple-task-block__row'}>
            <input
              id={'task-required'}
              type={'checkbox'}
              value={simpleTaskData['task_required']}
              checked={!!simpleTaskData['task_required']}
              onChange={() =>
                handleChangeData(
                  'task_required',
                  simpleTaskData['task_required'] ? 0 : 1
                )
              }
            />
            <label htmlFor={'task-required'}>Обязательное задание</label>
          </div>
          <button
            disabled={
              !simpleTaskData['caption'] ||
              !simpleTaskData['module_id'] ||
              (!simpleTaskData['description'] &&
                simpleTaskData['type'] === 'text') ||
              (!simpleTaskData['notion_description_id'] &&
                simpleTaskData['type'] === 'notion')
            }
            onClick={() =>
              simpleTaskBlockId ? handleUpdateBlock() : handleCreateBlock()
            }
            style={{ marginTop: 10 }}
          >
            {simpleTaskBlockId ? 'Сохранить' : 'Добавить'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
